import { generateEnumsFromKeys } from "@/src-refactor/modules/shared/helpers/generate-enums-from-keys";

export interface IAssessmentForm {
  subject_id: number;
  rating: number;
  comment: string;
  isProject: boolean;
}

export const assessmentInitialForm: IAssessmentForm = {
  comment: "",
  rating: 0,
  subject_id: 0,
  isProject: false
};

type ModelKeys<T> = Record<keyof T, string>;

const getKeyEnums = <T>(obj: T): ModelKeys<T> => {
  return generateEnumsFromKeys(obj as any);
};

export const ASSESSMENT_FORM_ENUMS = getKeyEnums(assessmentInitialForm);
